<eui-icon role="button" euiSize2XL iconClass="eui-icon-bell" styleClass="eui-u-cursor-pointer" (click)="onClicked($event)">
    <eui-badge *ngIf="count" euiSizeXS euiDanger>{{count}}</eui-badge>
</eui-icon>

<eui-overlay [isActive]="isOverlayActive">
    <eui-overlay-header euiPrimary>
        <h4 class="eui-u-text-center">Notifications</h4>

        <div class="eui-overlay-header-toolbar">
            <eui-icon iconClass="eui-icon-close-m eui-u-color-grey eui-u-cursor-pointer"></eui-icon>
        </div>
    </eui-overlay-header>
    <eui-overlay-body>
        <ul class="eui-notifications-items" *ngIf="items">
            <li *ngFor="let item of items" class="eui-notification-item">
                <div class="label-wrapper">
                    <div class="label">{{item.label}}</div>
                    <div class="sub-label">{{item.subLabel}}</div>
                </div>

                <div class="date-wrapper">
                    <div class="date">{{item.date}}</div>
                    <div class="days-from">
                        x days ago
                    </div>
                </div>
            </li>
        </ul>
    </eui-overlay-body>
    <eui-overlay-footer>
        <div class="eui-u-text-center"><a>View all notifications</a></div>
    </eui-overlay-footer>
</eui-overlay>
